import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import CheckBox from "@kit/design/checkbox"
import Icon from "@kit/design/icon"
import useScreenDimensions from "hooks/use-screen-dimensions"

function CheckFilter({
  title,
  filterItemsName,
  outputId,
  categories,
  setCategories,
  favoritesFilter = false
}) {
  const [collapsed, toggleCollapse] = useState(false)
  const { width } = useScreenDimensions(100)

  useEffect(() => {
    if (width >= 1024) {
      toggleCollapse(false)
    }
  }, [width])

  const updateSelections = currentCategory => {
    let clonedCategories = [...categories]
    clonedCategories.map(category => {
      if (category.name == currentCategory.name) {
        category.selected = !currentCategory.selected
      }
    })
    setCategories(clonedCategories)
  }

  const selectAll = () => {
    if (categories.find(item => item.selected) || favoritesFilter) {
      setCategories(
        categories.map(category => ({ ...category, selected: false }))
      )
    }
  }

  return (
    <div className="rounded my-8 lg:mt-0 lg:sticky top-0 border border-gray-200">
      <button
        className="uppercase h-12 px-4 font-bold flex items-center justify-between w-full lg:focus:outline-none cursor-pointer lg:cursor-auto bg-gray-50 text-blue-500"
        aria-expanded={!collapsed}
        aria-controls="filterList"
        role={width >= 1024 ? "presentation" : "button"}
        onClick={() =>
          window.innerWidth < 1024 ? toggleCollapse(!collapsed) : null
        }
      >
        <h3>Filter by {title}</h3>
        <Icon
          name="down"
          className={`lg:hidden transform transition-transform duration-200 text-xl ease-in-out ${
            collapsed ? "rotate-180" : ""
          }`}
        />
      </button>
      <ul
        id="filterList"
        role="region"
        className="list-none p-4 grid lg:block border-t border-gray-200"
        style={{
          gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
          display: collapsed ? "none" : "grid"
        }}
      >
        <li className="pb-3">
          <CheckBox
            aria-controls={outputId}
            id="chkflt-all"
            checked={
              categories.find(item => item.selected) || favoritesFilter
                ? false
                : true
            }
            onChange={selectAll}
            color="blue"
          />
          <label
            htmlFor="chkflt-all"
            className={`ml-2 mb-0 align-bottom text-base ${
              categories.find(item => item.selected) || favoritesFilter
                ? ""
                : "font-bold"
            }`}
          >
            All {filterItemsName || title}
          </label>
        </li>
        {categories.map(category => (
          <li className="pb-3" key={category.name}>
            <CheckBox
              checked={category.selected}
              aria-controls={outputId}
              id={`chkflt-${category.name}`}
              onChange={() => updateSelections(category)}
              color="blue"
            />
            <label
              htmlFor={`chkflt-${category.name}`}
              className={`ml-2 mb-0 align-bottom text-base ${
                category.selected ? "font-bold" : ""
              }`}
            >
              {category.name}
            </label>
          </li>
        ))}
      </ul>
    </div>
  )
}

// outputId prop for a11y
CheckFilter.propTypes = {
  title: PropTypes.string.isRequired,
  filterItemsName: PropTypes.string,
  outputId: PropTypes.string.isRequired,
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      selected: PropTypes.bool.isRequired
    })
  ).isRequired,
  setCategories: PropTypes.func.isRequired,
  favoritesFilter: PropTypes.bool
}

export default CheckFilter
